import React from 'react';
import * as _ from 'lodash';
import { closeIconSvg } from '../../HelperMethods/constants';

function withOverlay(Component) {
  return class extends React.Component {
    constructor(props) {
      super();
      const { defaultShow } = props;
      this.state = {
        showComponent: !!defaultShow,
      };
    }

    componentWillUnmount() {
      if (this.props.onHideComponent) this.props.onHideComponent();
    }

    showComponent = () => {
      this.setState({ showComponent: true });
    };

    hideComponent = () => {
      const { onHideComponent } = this.props;
      this.setState({ showComponent: false });
      if (onHideComponent) {
        onHideComponent();
      }
    };

    getPositionObject = () => {
      const { top, bottom, left, right } = this.props;
      const positionObject = { top, bottom, left, right };
      for (const key in positionObject) {
        if (_.isNil(positionObject[key])) {
          delete positionObject[key];
        }
      }
      if (_.isNil(positionObject.top) && _.isNil(positionObject.bottom)) {
        Object.assign(positionObject, { bottom: '51px' }); // default bottom value
      }
      if (_.isNil(positionObject.left) && _.isNil(positionObject.right)) {
        Object.assign(positionObject, { right: '0px' }); // default right value
      }
      return positionObject;
    };

    render() {
      const { showComponent } = this.state;
      const { overlayDisabled } = this.props;
      const boxStyle = { zIndex: '99', position: 'fixed', padding: '0px' };
      Object.assign(boxStyle, this.getPositionObject());
      return (
        <>
          {showComponent && (
            <>
              {!overlayDisabled && <div className="overlay-screen" onClick={this.hideComponent} />}
              <div style={boxStyle}>
                <div style={{ position: 'absolute', top: '10px', right: '12px', zIndex: '1' }}>
                  <img
                    src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(closeIconSvg)}`}
                    onClick={this.hideComponent}
                    style={{ cursor: 'pointer' }}
                    alt="Close Icon"
                  />
                </div>
                <Component {...this.props} />
              </div>
            </>
          )}
        </>
      );
    }
  };
}

export default withOverlay;
